import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(marketing)/error.tsx");
